import { render, staticRenderFns } from "./resume-toggle.vue?vue&type=template&id=45c2cff3&"
import script from "./resume-toggle.vue?vue&type=script&lang=js&"
export * from "./resume-toggle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports